// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"invoiceModal_modalContainer__3vSD9","closeButton":"invoiceModal_closeButton__1N-Ot","dialog":"invoiceModal_dialog__3KVbM"};